let templates_en = {
	async angl_career() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_career.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_s_mr() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_s_mr.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_s_mr_on() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_s_mr_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_s_or() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_s_or.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_s_or_on() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_s_or_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_ueb_on() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_ueb_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_ueb_spr() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_ueb_spr.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_ueb_spr_on() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_ueb_spr_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async angl_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/angl_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ashd() {
		const templateLoader = () => import("@/assets/js/templates_en/ashd.js");
		const template = await templateLoader();
		return template.default;
	},
	async ashd_k() {
		const templateLoader = () => import("@/assets/js/templates_en/ashd_k.js");
		const template = await templateLoader();
		return template.default;
	},
	async bio_s_or() {
		const templateLoader = () => import("@/assets/js/templates_en/bio_s_or.js");
		const template = await templateLoader();
		return template.default;
	},
	async bio_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/bio_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async bio_vl_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/bio_vl_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_heidenreich_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_heidenreich_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_heidenreich_ueb_on() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_heidenreich_ueb_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_heidenreich_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_heidenreich_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_heidenreich_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_heidenreich_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_maass_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_maass_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_maass_vl_capstone() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_maass_vl_capstone.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_maass_vl_off() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_maass_vl_off.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_morana() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_morana.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_stat_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_stat_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_stat_ueb_on() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_stat_ueb_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_stat_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_stat_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_stat_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_stat_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_strohmeier_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_strohmeier_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async bwl_strohmeier_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/bwl_strohmeier_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async cec() {
		const templateLoader = () => import("@/assets/js/templates_en/cec.js");
		const template = await templateLoader();
		return template.default;
	},
	async ceus() {
		const templateLoader = () => import("@/assets/js/templates_en/ceus.js");
		const template = await templateLoader();
		return template.default;
	},
	async ceus_on() {
		const templateLoader = () => import("@/assets/js/templates_en/ceus_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ch_fd_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/ch_fd_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ch_p() {
		const templateLoader = () => import("@/assets/js/templates_en/ch_p.js");
		const template = await templateLoader();
		return template.default;
	},
	async ch_p_m() {
		const templateLoader = () => import("@/assets/js/templates_en/ch_p_m.js");
		const template = await templateLoader();
		return template.default;
	},
	async ch_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/ch_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async ch_vl_m() {
		const templateLoader = () => import("@/assets/js/templates_en/ch_vl_m.js");
		const template = await templateLoader();
		return template.default;
	},
	async coli_s_mr() {
		const templateLoader = () => import("@/assets/js/templates_en/coli_s_mr.js");
		const template = await templateLoader();
		return template.default;
	},
	async coli_s_mr_on() {
		const templateLoader = () => import("@/assets/js/templates_en/coli_s_mr_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async coli_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/coli_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async coli_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/coli_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async coli_vl_t() {
		const templateLoader = () => import("@/assets/js/templates_en/coli_vl_t.js");
		const template = await templateLoader();
		return template.default;
	},
	async coli_vl_t_on() {
		const templateLoader = () => import("@/assets/js/templates_en/coli_vl_t_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_s() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_s.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_s_on() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_s_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_ueb_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_ueb_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_ueb_dsp_on() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_ueb_dsp_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_ueb_usp() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_ueb_usp.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async dfki_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/dfki_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async edutech_s() {
		const templateLoader = () => import("@/assets/js/templates_en/edutech_s.js");
		const template = await templateLoader();
		return template.default;
	},
	async edutech_s_on() {
		const templateLoader = () => import("@/assets/js/templates_en/edutech_s_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async edutech_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/edutech_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async edutech_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/edutech_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ezw_s_ag() {
		const templateLoader = () => import("@/assets/js/templates_en/ezw_s_ag.js");
		const template = await templateLoader();
		return template.default;
	},
	async ezw_s_ag_on() {
		const templateLoader = () => import("@/assets/js/templates_en/ezw_s_ag_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ezw_s_mr_ag() {
		const templateLoader = () => import("@/assets/js/templates_en/ezw_s_mr_ag.js");
		const template = await templateLoader();
		return template.default;
	},
	async ezw_s_mr_ag_on() {
		const templateLoader = () => import("@/assets/js/templates_en/ezw_s_mr_ag_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ezw_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/ezw_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async geo_s_or() {
		const templateLoader = () => import("@/assets/js/templates_en/geo_s_or.js");
		const template = await templateLoader();
		return template.default;
	},
	async geo_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/geo_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async globalclass() {
		const templateLoader = () => import("@/assets/js/templates_en/globalclass.js");
		const template = await templateLoader();
		return template.default;
	},
	async gpp() {
		const templateLoader = () => import("@/assets/js/templates_en/gpp.js");
		const template = await templateLoader();
		return template.default;
	},
	async gradus() {
		const templateLoader = () => import("@/assets/js/templates_en/gradus.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_mp() {
		const templateLoader = () => import("@/assets/js/templates_en/info_mp.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_mv() {
		const templateLoader = () => import("@/assets/js/templates_en/info_mv.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_p() {
		const templateLoader = () => import("@/assets/js/templates_en/info_p.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_p_on() {
		const templateLoader = () => import("@/assets/js/templates_en/info_p_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_ps() {
		const templateLoader = () => import("@/assets/js/templates_en/info_ps.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_s() {
		const templateLoader = () => import("@/assets/js/templates_en/info_s.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_s_on() {
		const templateLoader = () => import("@/assets/js/templates_en/info_s_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_t() {
		const templateLoader = () => import("@/assets/js/templates_en/info_t.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_t_on() {
		const templateLoader = () => import("@/assets/js/templates_en/info_t_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/info_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async info_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/info_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ing_p() {
		const templateLoader = () => import("@/assets/js/templates_en/ing_p.js");
		const template = await templateLoader();
		return template.default;
	},
	async ing_p_on() {
		const templateLoader = () => import("@/assets/js/templates_en/ing_p_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async ing_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/ing_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async ing_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/ing_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async isz() {
		const templateLoader = () => import("@/assets/js/templates_en/isz.js");
		const template = await templateLoader();
		return template.default;
	},
	async isz_on() {
		const templateLoader = () => import("@/assets/js/templates_en/isz_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async mathe_t() {
		const templateLoader = () => import("@/assets/js/templates_en/mathe_t.js");
		const template = await templateLoader();
		return template.default;
	},
	async mathe_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/mathe_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async mathe_vl_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/mathe_vl_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async mathe_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/mathe_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async matwis_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/matwis_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async matwis_ueb_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/matwis_ueb_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async matwis_ueb_on() {
		const templateLoader = () => import("@/assets/js/templates_en/matwis_ueb_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async matwis_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/matwis_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async matwis_vl_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/matwis_vl_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async matwis_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/matwis_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async med_vl_alt() {
		const templateLoader = () => import("@/assets/js/templates_en/med_vl_alt.js");
		const template = await templateLoader();
		return template.default;
	},
	async med_vl_alt_on() {
		const templateLoader = () => import("@/assets/js/templates_en/med_vl_alt_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async optio_s_or() {
		const templateLoader = () => import("@/assets/js/templates_en/optio_s_or.js");
		const template = await templateLoader();
		return template.default;
	},
	async pharm_p_mr_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/pharm_p_mr_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async pharm_vl_usp() {
		const templateLoader = () => import("@/assets/js/templates_en/pharm_vl_usp.js");
		const template = await templateLoader();
		return template.default;
	},
	async pharm_vl_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/pharm_vl_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async philo() {
		const templateLoader = () => import("@/assets/js/templates_en/philo.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_ueb() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_ueb.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_ueb_on() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_ueb_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_ueb_t() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_ueb_t.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_ueb_t_on() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_ueb_t_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async phys_vl_s() {
		const templateLoader = () => import("@/assets/js/templates_en/phys_vl_s.js");
		const template = await templateLoader();
		return template.default;
	},
	async psy_s_ag_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/psy_s_ag_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async rom_ueb_on() {
		const templateLoader = () => import("@/assets/js/templates_en/rom_ueb_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async servicelearning() {
		const templateLoader = () => import("@/assets/js/templates_en/servicelearning.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_ag() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_ag.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_ag_on() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_ag_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_mr() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_mr.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_mr_ag() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_mr_ag.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_mr_ag_on() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_mr_ag_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_or() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_or.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_s_or_on() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_s_or_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_vl() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_vl.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_vl_dsp() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_vl_dsp.js");
		const template = await templateLoader();
		return template.default;
	},
	async sonst_vl_on() {
		const templateLoader = () => import("@/assets/js/templates_en/sonst_vl_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async sport() {
		const templateLoader = () => import("@/assets/js/templates_en/sport.js");
		const template = await templateLoader();
		return template.default;
	},
	async sz() {
		const templateLoader = () => import("@/assets/js/templates_en/sz.js");
		const template = await templateLoader();
		return template.default;
	},
	async prowis() {
		const templateLoader = () => import("@/assets/js/templates_en/prowis.js");
		const template = await templateLoader();
		return template.default;
	},
	async zell() {
		const templateLoader = () => import("@/assets/js/templates_en/zell.js");
		const template = await templateLoader();
		return template.default;
	},
	async zell_on() {
		const templateLoader = () => import("@/assets/js/templates_en/zell_on.js");
		const template = await templateLoader();
		return template.default;
	},
	async zesh() {
		const templateLoader = () => import("@/assets/js/templates_en/zesh.js");
		const template = await templateLoader();
		return template.default;
	},
	async zesh_on() {
		const templateLoader = () => import("@/assets/js/templates_en/zesh_on.js");
		const template = await templateLoader();
		return template.default;
	},
};
export default templates_en;
